import React, { useEffect } from "react";

import analytics from "src/shared/contact-boxes/experts/utilities/analytics";
import useFeatureState from "src/shared/contact-boxes/experts/utilities/hooks/useFeatureState";
import useReducerActions from "src/shared/contact-boxes/experts/utilities/useReducerActions";

import * as S from "./styled";

const LandLeaseModal = () => {
  const {
    dispatchSetContactFormType,
    dispatchSetWhatYouShouldKnowModal
  } = useReducerActions();
  const { contactFormType, expertsApiUuid, isModalOpen } = useFeatureState();
  const onRequestClose = () =>
    dispatchSetWhatYouShouldKnowModal({
      contactFormType: null,
      isModalOpen: false
    });

  useEffect(() => {
    if (isModalOpen) {
      analytics({
        action: "impressions_for_land_lease_info",
        isHdp: true,
        label: `uuid=${expertsApiUuid}|from=${
          contactFormType ? "contact" : "link"
        }`,
        unique: true
      });
    }
  }, [isModalOpen]);

  return (
    <S.Modal
      data-qa="land-lease-modal"
      isOpen={Boolean(isModalOpen)}
      onRequestClose={onRequestClose}
    >
      <S.LandLeaseSaleModalTitle>
        <S.Title>What You Should Know About Land-Lease Buildings</S.Title>
      </S.LandLeaseSaleModalTitle>
      <S.ModalBody>
        <S.SubTitle>Higher operational fees</S.SubTitle>
        <S.Text>
          To help cover the building’s ground rent, you can expect to pay higher
          operational fees. These are your maintenance fees in co-ops and common
          charges in condos.
        </S.Text>
        <S.SubTitle>Limited property tax reductions</S.SubTitle>
        <S.Text>
          Because land-lease buildings don’t own their land, they don’t pay real
          estate taxes. As a homeowner, you can expect to have limited access to
          property tax deductions.
        </S.Text>
        <S.SubTitle>Strict mortgage application reviews</S.SubTitle>
        <S.Text>
          Banks watch out for land leases with less than 30 years left. If a
          lease expires before you pay off a mortgage, you can face extra
          charges from the building and present liability to a bank.
        </S.Text>
        <S.ButtonContainer>
          {contactFormType ? (
            <S.Button
              onClick={() => {
                dispatchSetContactFormType(contactFormType);
              }}
            >
              Got it, continue
            </S.Button>
          ) : (
            <S.Button onClick={onRequestClose}>Got it</S.Button>
          )}
        </S.ButtonContainer>
        <S.Link
          href="https://streeteasy.com/blog/what-is-a-land-lease-building-in-nyc/"
          onClick={() => {
            analytics({
              action: "click_to_land_lease_blog",
              isHdp: true,
              label: `uuid=${expertsApiUuid}|from=${
                contactFormType ? "contact" : "link"
              }`
            });
          }}
          target="_blank"
        >
          read about land-lease buildings on our blog
        </S.Link>
      </S.ModalBody>
    </S.Modal>
  );
};

export default LandLeaseModal;
